import type { ReactNode } from "react";
import { type BorderRadius, Colors, type TextAlignment } from "schemas";
import { LinkButton } from "../../components/LinkButton";
import type { ButtonBlockType } from "./ButtonBlock";

const IconsLight: Record<ButtonBlockType, string> = {
  Phone: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/48ff6b3b-7f5a-4367-1511-cf0e4b636200/logo",
  Email: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/6195bdbb-b82a-4517-0ecd-9caf2a146b00/logo",
  Link: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/a2c7e428-e2ef-4462-6023-690582e19c00/logo",
};
const IconsDark: Record<ButtonBlockType, string> = {
  Phone: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/a389cf4d-3b1e-4668-ca0d-063a0cc91400/logo",
  Email: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/39220c3d-0126-4403-984e-df17d2d14d00/logo",
  Link: "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/ca8740ba-50d7-4320-56c6-98f4ed3fb200/logo",
};

type Props = {
  contentRef: (node: HTMLElement | null) => void;
  buttonType: ButtonBlockType;
  url: string;
  phone: string;
  email: string;
  extra?: ReactNode;
  neutered?: boolean;
  buttonBackgroundColor: string;
  buttonTextColor: string;
  buttonTextAlignment: TextAlignment;
  buttonBorderRadius: BorderRadius;
};
export function InlineButton({
  contentRef,
  buttonType,
  url,
  phone,
  email,
  extra,
  neutered,
  buttonBackgroundColor,
  buttonTextColor,
  buttonTextAlignment,
  buttonBorderRadius,
}: Props) {
  const iconsCollection = buttonTextColor === Colors.Neutral0 ? IconsLight : IconsDark;
  const href = () => {
    if (neutered) {
      return "#";
    }
    switch (buttonType) {
      case "Email":
        return email ? `mailto:${email}` : "#";
      case "Phone":
        return phone ? `tel:${phone}` : "#";
      case "Link":
        return url || "#";
    }
  };

  return (
    <LinkButton
      href={href()}
      iconSrc={iconsCollection[buttonType]}
      contentRef={contentRef}
      extra={extra}
      buttonTextColor={buttonTextColor}
      buttonBackgroundColor={buttonBackgroundColor}
      buttonTextAlignment={buttonTextAlignment}
      buttonBorderRadius={buttonBorderRadius}
    />
  );
}
